// extracted by mini-css-extract-plugin
export default {"wrapper":"EmailVerification_wrapper__Uk8gG"};